import * as Styled from './meeting-room-tooltip.styles';
import {useTranslation} from 'react-i18next';
import {memo} from 'react';

import {Button, Icon, Tooltip, Typography, useTheme} from '@innowise-group/ui-kit';
import {MeetingRoomData} from '../plan-element-view';
import {MeetingRoomStatus} from '../meeting-room-status';

interface MeetingRoomTooltipProps {
  isViewMode: boolean;
  meetingRoomData: MeetingRoomData | null;
  selected: boolean;
  onOpenBookingModal: () => void;
  timeRemaining: string;
  children: React.ReactElement;
}

const MeetingRoomTooltip = ({
  isViewMode,
  meetingRoomData,
  selected,
  onOpenBookingModal,
  timeRemaining,
  children,
}: MeetingRoomTooltipProps) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <Tooltip
      vertical="top"
      horizontal="center"
      active={selected}
      content={
        isViewMode && !!meetingRoomData?.meetingRoomId ? (
          <Styled.FadeInOutViewWrap>
            <Styled.Content>
              <Icon type="u_users-alt" fill={theme.palette.specials.meetings.icon} />
              <Typography type="h3">{meetingRoomData?.capacity}</Typography>
              <MeetingRoomStatus meetingRoomStatus={meetingRoomData?.isBusy} timeRemaining={timeRemaining} />
            </Styled.Content>
            <Button onClick={onOpenBookingModal} icon="u_bookmark" iconSize={16}>
              {t('buttons.book')}
            </Button>
          </Styled.FadeInOutViewWrap>
        ) : null
      }
    >
      {children}
    </Tooltip>
  );
};

export default memo(MeetingRoomTooltip);
